import { render, staticRenderFns } from "./OtherDeliveryUpsertForm.vue?vue&type=template&id=1624e09a"
import script from "./OtherDeliveryUpsertForm.vue?vue&type=script&lang=js"
export * from "./OtherDeliveryUpsertForm.vue?vue&type=script&lang=js"
import style0 from "./OtherDeliveryUpsertForm.vue?vue&type=style&index=0&id=1624e09a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports